import appConst from "./appConst.json";

let _braze = null;
async function getBraze() {
  if (!_braze) _braze = await import("@braze/web-sdk");
  return _braze;
}
let token = "";
let product = "";
let platform = "";
let device = "";
let sourceDevice = "";
let language = "";
let isNewsletter = "";
let showHeader = "";

export const setToken = (t) => {
  token = t;
};
export const setProduct = (p) => {
  product = p;
};
export const setLanguage = (l) => {
  language = l;
};
export const setPlatform = (p) => {
  platform = p;
};
export const setDevice = (d) => {
  device = d;
};
export const setSourceDevice = (sd) => {
  sourceDevice = sd;
};
export const setNewsletter = (n) => {
  isNewsletter = n;
};
export const setShowHeader = (s) => {
  showHeader = s;
};

export const get_req = async function (url) {
  await checkUserTime();
  if (token === "") {
    token = sessionStorage.getItem(appConst.TOKEN);
  }
  if (platform === "") {
    platform = sessionStorage.getItem(appConst.PLATFORM);
  }
  if (device === "") {
    device = sessionStorage.getItem(appConst.DEVICE);
  }
  if (sourceDevice === "") {
    sourceDevice = sessionStorage.getItem(appConst.SOURCE_DEVICE);
  }
  if (product === "") {
    product = sessionStorage.getItem(appConst.PRODUCT);
  }
  if (isNewsletter === "") {
    isNewsletter = sessionStorage.getItem(appConst.IS_NEWSLETTER);
  }

  try {
    const response = await fetch(
      `${url}&source_type=${product}&lang=${language}&platform=${platform}&device=${device}&source_device=${sourceDevice}&show_header=${showHeader}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    let data = await response.json();
    return data;
  } catch (error) {
    return {
      isValid: false,
      errorCode: appConst.ERROR_CODE_GET_REQUEST,
      errorMessage: error?.message || String(error),
    };
  }
};

export const post_req = async function (url, dataBody) {
  await checkUserTime();
  if (token === "") {
    token = sessionStorage.getItem(appConst.TOKEN);
  }
  if (platform === null) {
    platform = sessionStorage.getItem(appConst.PLATFORM);
  }
  if (device === "") {
    device = sessionStorage.getItem(appConst.DEVICE);
  }
  if (sourceDevice === null) {
    sourceDevice = sessionStorage.getItem(appConst.SOURCE_DEVICE);
  }
  if (product === "") {
    product = sessionStorage.getItem(appConst.PRODUCT);
  }
  if (isNewsletter === false) {
    isNewsletter = sessionStorage.getItem(appConst.IS_NEWSLETTER);
  }

  const requestOptions = {
    method: "post",
    headers: { Authorization: `Bearer ${token}` },
    body: dataBody instanceof FormData ? dataBody : JSON.stringify(dataBody),
  };
  try {
    const response = await fetch(
      `${url}&source_type=${product}&lang=${language}&platform=${platform}&device=${device}&source_device=${sourceDevice}&show_header=${showHeader}&newsletter=${isNewsletter}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return {
      isValid: false,
      errorCode: appConst.ERROR_CODE_POST_REQUEST,
      // Return a string, never the raw Error object: it flows into alert state
      // and gets rendered as a React child (React error #31) downstream.
      errorMessage: error?.message || String(error),
    };
  }
};

async function checkUserTime() {
  const time = sessionStorage.getItem("dateStart") || new Date().getTime();
  const dateEnd = new Date().getTime();
  const minutes = ((dateEnd - time) / (1000 * 3600)) * 100;
  if (minutes > appConst.EXPIRED_TIME) {
    sessionStorage.clear();
    // Clear Braze user on logout so the next user starts with a clean session.
    const braze = await getBraze();
    braze.wipeData();
    window.location.pathname = "";
  }
}
